export default "/react/logoLiveTex-c5be81a6.png";